import { connect } from "react-redux";
import GlobalSettingsComponent from "../../Components/GlobalSettings/GlobalSettingsComponent";
import { setConsentedApps } from "../../Redux/Actions/ConsentActions";
// ============ Redux Connection - ONLY Redux state and dispatch ============

const mapStateToProps = (state) => ({
  consentedApps: state.reducer.consentedApps || [],
  ACTIVE_TENANT: state.reducer.ACTIVE_TENANT,
  store_activeScope: state.reducer.store_activeScope,
  bootstrapMode: state.reducer.bootstrapMode
});

const mapDispatchToProps = (dispatch) => ({
     setConsentedApps: (consentedApps) => dispatch(setConsentedApps(consentedApps)),
 
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(GlobalSettingsComponent);
